/**
 * Un color por médico, siempre el mismo para el mismo `party_id`.
 *
 * Ocho tonos discretos, elegidos para no chocar con los colores semánticos
 * del sistema (`--ok` verde, `--warn` ámbar, `--danger` rojo siguen
 * significando lo mismo en todos lados). El hash es determinístico: no hace
 * falta guardar el color de nadie, se deriva del id cada vez.
 *
 * La rejilla anual que antes vivía en este archivo (`PeriodGrid`, la que
 * pintaba doce celdas de un mes cada una) se fusionó en `Distribution.tsx`
 * — bloques de meses consecutivos en vez de celdas sueltas, con la misma
 * paleta. Esta función es lo único que sigue compartiéndose desde acá.
 *
 * Los ocho tonos son los tokens `--payer-1..8` de `base.css` (WP4, auditoría
 * de interfaces 1-sep-2026): antes eran literales hexadecimales acá, sueltos
 * del resto del sistema de diseño. `var(--payer-N)` funciona igual que un
 * color fijo como valor de la custom property `--payer-color` que consume
 * `app.css` (`payer-chip__dot`, `.dist-block`, etc.) — el navegador resuelve
 * la cadena de variables sin que a esta función le importe.
 */

const PAYER_PALETTE = [
  'var(--payer-1)', 'var(--payer-2)', 'var(--payer-3)', 'var(--payer-4)',
  'var(--payer-5)', 'var(--payer-6)', 'var(--payer-7)', 'var(--payer-8)',
];

export function payerColor(partyId: string): string {
  let hash = 0;
  for (let i = 0; i < partyId.length; i += 1) hash = (hash * 31 + partyId.charCodeAt(i)) | 0;
  return PAYER_PALETTE[Math.abs(hash) % PAYER_PALETTE.length]!;
}
